import { Inject } from '@odinjs/odin';
import { FragmentNames } from '../../../codegen';
import BaseController from '../../BaseController';
import { Controller } from '@philips-internal/oswald-ui-core/lib/client/controller';
import { OnClick, OnMount, OnReadSuccess } from '@philips-internal/oswald-ui-core/lib/client';
import { MapperAPI, ToastService } from '@philips-internal/oswald-ui-components';
import { DeliveringMealsBySequenceAliases } from '../../../codegen/constants/aliases/delivering-meals-by-sequence-aliases';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { ApplicationRoute } from '../../../constants/routes';
import { Endpoint } from '../../../constants/endpoints';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Placement, ToastLevel, ToastType } from '@philips-internal/oswald-ui-constants';
import { Value } from '@philips-internal/oswald-ui-core';

enum MealStatus {
  Delivered = 'SE',       // Serviço entregue
  Expired = 'DC',         // Com data de corte
  NotReleased = 'DL',     // Sem data de liberação
}
@Controller({ component: DeliveringMealsBySequenceAliases.LAYOUT_DELIVERING_MEALS, fragment: FragmentNames.DELIVERING_MEALS_BY_SEQUENCE })
class MealSequeceVerifiedController extends BaseController {

  @Inject(DeliveringMealsBySequenceAliases.DELIVERING_MEALS_DECK)
  private readonly selectedMealsMapperAPI!: MapperAPI;

  @OnMount({ target: DeliveringMealsBySequenceAliases.LAYOUT_DELIVERING_MEALS })
  handleMountLayout(): void {
    const {
      departmentCode,
      encounterId,
      patientId
    } = this.historyService.getCurrentRouteParams();

    this.context.set({
      departmentCode,
      encounterId,
      patientId
    });
  }

  @OnReadSuccess({ target: DeliveringMealsBySequenceAliases.BARCODE_COMPONENT })
  handleReadSuccess(event: Record<string, Value>): void {
    const params = event.item as Record<string, string>;
    const sequenceService = params.value;
    this.context.set({ sequenceService });
    this.verifySequenceService();
  }

  verifySequenceService(): Promise<void> {
    const encounterId = this.context.get('encounterId') as string;
    const sequenceService = this.context.get('sequenceService') as string;
    return HttpService.get(Endpoint.VERIFY_SEQUENCE_SERVICE, { encounterId: encounterId, sequenceService: sequenceService }).then((response) => {
      let listMeals = response.body as Record<string, unknown>[];
      if (!listMeals || listMeals.length === 0) {
        this.showToast('meal-delivery.invalid-sequence-service', ToastLevel.ERROR);
        return;
      }

      const [{ status }] = listMeals;

      switch (status) {
        case MealStatus.Delivered:
          this.showToast('meal-delivery.service-already-delivered', ToastLevel.ERROR);
          return;
        case MealStatus.Expired:
          this.showToast('meal-delivery.date-expired', ToastLevel.ERROR);
          return;
        case MealStatus.NotReleased:
          this.showToast('meal-delivery.without-release-date', ToastLevel.ERROR);
          return;
      }

      const oldMealsInformations = this.context.get('oldMealsInformations') as Record<string, unknown>[];
      if (oldMealsInformations) {
        const sequenceServiceExists = oldMealsInformations.some(meal => meal.sequenceService === sequenceService);
        if (sequenceServiceExists) {
          this.showToast('meal-delivery.service-already-selected', ToastLevel.WARNING);
          return;
        }
      }

      listMeals = this.addSequenceService(listMeals, sequenceService);
      const allMeals = oldMealsInformations ? [...oldMealsInformations, ...listMeals] : listMeals;

      const allSequences = allMeals.map(meal => meal.sequenceService);
      this.context.set({ allSequences: allSequences });

      this.handlerMountMapper(allMeals);

    }).catch(() => {
      this.showToast('meal-delivery.invalid-sequence-service', ToastLevel.ERROR);
    });
  }
  handlerMountMapper(listMeals: Record<string, unknown>[]): void {
    this.context.set({ oldMealsInformations: listMeals });
    this.selectedMealsMapperAPI.setData(listMeals.map(meal => { return { data: meal } }));
  }

  addSequenceService(items: Record<string, unknown>[], sequence: unknown): Record<string, unknown>[] {
    return items.map(item => ({ ...item, sequenceService: sequence }));
  }

  showToast(message: string, level: ToastLevel): void {
    ToastService.open({
      dismissible: true,
      highlight: false,
      id: 'meal-delivery-toast',
      level,
      message,
      placement: Placement.BOTTOM,
      showIcon: true,
      timeout: 5000,
      type: ToastType.BANNER,
    });
  }

  @OnClick({ target: DeliveringMealsBySequenceAliases.APPLY_BUTTON })
  handleOnClickApply(): void {
    const allSequences = this.context.get('allSequences') as string;
    const encounterId = this.context.get('encounterId') as string;
    const departmentCode = this.context.get('departmentCode') as string;
    const patientId =  this.context.get('patientId') as string;

    HttpService.get(Endpoint.UPDATE_SERVICE, { allSequences: allSequences, departmentCode: departmentCode, encounterId: encounterId, patientId: patientId }).then(() => {
      applicationContext.redirect(ApplicationRoute.MEAL_DELIVERY_PATIENT, {
        departmentCode: departmentCode,
        encounterId: encounterId,
        patientId: this.context.get('patientId'),
      });
    }).catch(() => {
      this.showToast('meal-delivery.invalid-sequence-service', ToastLevel.ERROR);
    });
  }

  @OnClick({ target: DeliveringMealsBySequenceAliases.CLEAN_BUTTON })
  handleOnClickClean(): void {
    this.selectedMealsMapperAPI.setData([]);
    this.context.set({ allSequences: [] });
    this.context.set({ oldMealsInformations: [] });
    this.context.set({ sequenceService: '' });
  }

}

export default MealSequeceVerifiedController;
